import React from 'react';
import { IconProps } from 'components/icons/types';

export const TelegramSquare = ({ className }: IconProps) => {
  return (
    <svg
      viewBox="0 0 14 15"
      className={className}
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.25" width="14" height="14" rx="3" fill="url(#paint0_linear_912_7532)" />
      <path
        d="M4.73828 7.76145L5.56877 10.0601C5.56877 10.0601 5.67261 10.2752 5.78379 10.2752C5.89497 10.2752 7.54866 8.55485 7.54866 8.55485L9.38762 5.00293L4.76791 7.16809L4.73828 7.76145Z"
        fill="#C8DAEA"
      />
      <path
        d="M5.83995 8.35156L5.68053 10.0459C5.68053 10.0459 5.61379 10.5651 6.13284 10.0459C6.65189 9.52675 7.14872 9.1264 7.14872 9.1264"
        fill="#A9C6D8"
      />
      <path
        d="M4.75337 7.84416L3.04502 7.28754C3.04502 7.28754 2.84086 7.20471 2.9066 7.01688C2.92013 6.97814 2.94743 6.94518 3.0291 6.88854C3.40762 6.6247 10.0353 4.24254 10.0353 4.24254C10.0353 4.24254 10.2224 4.17948 10.3328 4.22143C10.3601 4.22988 10.3847 4.24543 10.404 4.26649C10.4233 4.28756 10.4367 4.31337 10.4427 4.3413C10.4547 4.39063 10.4597 4.44138 10.4576 4.49209C10.457 4.53596 10.4517 4.57662 10.4477 4.64038C10.4073 5.29167 9.19936 10.1525 9.19936 10.1525C9.19936 10.1525 9.12709 10.4369 8.86815 10.4466C8.80451 10.4487 8.74112 10.4379 8.68174 10.4149C8.62236 10.392 8.56821 10.3573 8.52252 10.3129C8.01438 9.87585 6.25808 8.69553 5.86999 8.43595C5.86124 8.42999 5.85386 8.42221 5.84837 8.41316C5.84287 8.4041 5.83939 8.39397 5.83814 8.38345C5.83271 8.35609 5.86246 8.3222 5.86246 8.3222C5.86246 8.3222 8.92065 5.60387 9.00202 5.3185C9.00832 5.29639 8.98452 5.28548 8.95256 5.29517C8.74944 5.36989 5.22832 7.5935 4.83971 7.83891C4.81173 7.84737 4.78217 7.84917 4.75337 7.84416V7.84416Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_912_7532"
          x1="7"
          y1="14.25"
          x2="7"
          y2="0.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1D93D2" />
          <stop offset="1" stopColor="#38B0E3" />
        </linearGradient>
      </defs>
    </svg>
  );
};
